export const SWITCH_MODE = "SWITCH_MODE";